module.exports = "data:image/gif;base64,R0lGODlhCAAJAJEAABkjKQwRFIyRlAAAACH5BAAAAAAALAAAAAAIAAkAAAIRjA8QwmLa3InMUHkt1fF4UwAAOw=="